function getVariantImageUrl(parameterId, value) {
    var images = typeof shopDataLayer !== "undefined" && shopDataLayer.productDetail && shopDataLayer.productDetail.variantImages;
    if (!images) return "";
    var url = images[parameterId] && images[parameterId][value] ? images[parameterId][value] : "";
    return url || images.universal || "";
}

function hasParameterImages(parameterId) {
    var images = typeof shopDataLayer !== "undefined" && shopDataLayer.productDetail && shopDataLayer.productDetail.variantImages;
    if (!images || !images[parameterId] || typeof images[parameterId] !== "object") return false;
    return Object.keys(images[parameterId]).length > 0;
}

function buildMyvariantsFromSelect($select) {
    var parameterId = $select.data("parameter-id") || $select.attr("id").replace("parameter-id-", "");
    var withImages = hasParameterImages(parameterId);
    var $wrapper = $("<div>")
        .addClass("myvariants" + (withImages ? " image-included" : ""))
        .attr("data-parameter-id", parameterId);

    $select.find("option").each(function () {
        var $opt = $(this);
        var value = $opt.val();
        if ($opt.data("choose") === true || value === "") return;

        var label = $opt.text().trim();
        var $variant = $("<div>")
            .addClass("myvariant")
            .attr("data-value", value)
            .attr("data-parameter-id", parameterId);

        $variant.append($("<span>").addClass("myvariant-name").text(label));

        if (withImages) {
            var imgUrl = getVariantImageUrl(parameterId, value);
            var $imgHolder = $("<div>").addClass("img-holder");
            $imgHolder.append($("<img>").attr({
                src: imgUrl,
                alt: label,
                loading: "eager"
            }));
            $variant.append($imgHolder);
        }

        $wrapper.append($variant);
    });

    return $wrapper;
}

// Nativní dlaždice variant jako tlačítka (ovládání klávesnicí) — zatím jen pro přihlášeného admina
function myvariantsPressed() {
    $(".myvariants button.myvariant").each(function () {
        $(this).attr("aria-pressed", String($(this).hasClass("selected")));
    });
}

function myvariantsToButtons() {
    if (!$("body").hasClass("admin-logged")) return;

    $(".variant-list .myvariants div.myvariant").each(function () {
        const $button = $("<button type='button'></button>");

        $.each(this.attributes, function (index, attribute) {
            $button.attr(attribute.name, attribute.value);
        });

        $button.append($(this).contents());
        $button.find("img").attr("alt", "");
        $(this).replaceWith($button);
    });

    myvariantsPressed();
}

if (typeof getShoptetDataLayer === "function" && getShoptetDataLayer("pageType") === "productDetail") {
    var _disTab = document.querySelector("#p-detail-tabs .shp-tab a[href='#productDiscussion']");
    if (_disTab && _disTab.closest(".shp-tab")) _disTab.closest(".shp-tab").remove();
    var _disPane = document.getElementById("productDiscussion");
    if (_disPane) _disPane.remove();
}

$(document).ready(function () {
    if (myDataLayer.pageType == "productDetail") {
        $(".p-short-description").prependTo(".p-info-wrapper");
        if ($(window).width() > 1199) {
            $(".p-detail-info .stars-wrapper").insertAfter(".p-short-description");
            $(".p-detail-inner-header").prependTo(".p-info-wrapper");
            $(".breadcrumbs-wrapper").prependTo(".p-info-wrapper");
            if ($(".p-thumbnails .p-thumbnail").length >= 3) {
                $("<div class='additional-gallery'><div class='img-holder'></div><div class='img-holder'></div></div>").insertAfter(".p-image");
                var $thumbnails = $(".p-thumbnails .p-thumbnail");
                var alt2 = $thumbnails.eq(1).find("img").attr("alt") || "";
                var alt3 = $thumbnails.eq(2).find("img").attr("alt") || "";
                var href2 = $thumbnails.eq(1).attr("href");
                var href3 = $thumbnails.eq(2).attr("href");
                var src2 = myImageSize($thumbnails.eq(1).find("img").attr("data-src") || $thumbnails.eq(1).find("img").attr("src"), "big");
                var src3 = myImageSize($thumbnails.eq(2).find("img").attr("data-src") || $thumbnails.eq(2).find("img").attr("src"), "big");
                var $link2 = $("<a>").attr({ href: href2, "data-gallery": "lightbox[gallery]", "data-alt": alt2 }).addClass("cbox-gal cboxElement").append($("<img>").attr({ src: src2, alt: alt2, loading: "lazy" }));
                var $link3 = $("<a>").attr({ href: href3, "data-gallery": "lightbox[gallery]", "data-alt": alt3 }).addClass("cbox-gal cboxElement").append($("<img>").attr({ src: src3, alt: alt3, loading: "lazy" }));
                $(".additional-gallery .img-holder").eq(0).append($link2);
                $(".additional-gallery .img-holder").eq(1).append($link3);
            }
            // Záložky (hodnocení, diskuze) mají vlastní formuláře s povinnými poli. Uvnitř
            // #product-detail-form by je Shoptet validátor bral jako pole košíku a blokoval
            // „Přidat do košíku" — proto formulář košíku obalí jen pravý sloupec, kde má
            // všechna svá pole, a řádek se sloupci jde ven z něj. Musí proběhnout dřív, než
            // Shoptet inicializuje validátor (jeho ready handler běží až po našem).
            var $cartForm = $("#product-detail-form");
            var $productTop = $cartForm.children(".product-top");
            var $infoWrapper = $productTop.children(".p-info-wrapper");
            if ($cartForm.length && $productTop.length && $infoWrapper.length) {
                $productTop.insertAfter($cartForm);
                $cartForm.append($infoWrapper.contents()).appendTo($infoWrapper);
            }
            $(".p-detail-tabs-wrapper").appendTo(".p-image-wrapper");
        }

        else {
            $(".p-short-description").prependTo(".p-detail-info");
            var $thumbnails = $(".p-thumbnails .p-thumbnail");
            var mobileGallerySwiper = null;
            if ($thumbnails.length || $(".p-main-image").length) {
                var singleImage = !$thumbnails.length || $thumbnails.length === 1;
                var $wrap = $("<div>").addClass("whole-wrap mobile-gallery" + (singleImage ? " mobile-gallery--single" : ""));
                var $swiper = $("<div>").addClass("swiper mobile-gallery-swiper");
                var $wrapper = $("<div>").addClass("swiper-wrapper");
                if ($thumbnails.length) {
                    $thumbnails.each(function (photoIndex) {
                        var $thumb = $(this);
                        var $img = $thumb.find("img");
                        var src = myImageSize($img.attr("data-src") || $img.attr("src") || "", "big");
                        var alt = $img.attr("alt") || "";
                        var $slide = $("<div>").addClass("swiper-slide").attr("data-photo-index", photoIndex);
                        $slide.append($("<img>").attr({ src: src, alt: alt, loading: "lazy" }));
                        $wrapper.append($slide);
                    });
                } else {
                    var $mainImg = $(".p-main-image img");
                    var src = $mainImg.attr("src") || "";
                    var alt = $mainImg.attr("alt") || "";
                    var $slide = $("<div>").addClass("swiper-slide");
                    $slide.append($("<img>").attr({ src: src, alt: alt, loading: "eager" }));
                    $wrapper.append($slide);
                }
                $swiper.append($wrapper);
                $wrap.append($swiper);
                if ($thumbnails.length > 1) {
                    $wrap.append($("<div class='myswiper-navi'><div class='swiper-button-prev myswiper-prev'>&nbsp;</div><div class='swiper-button-next myswiper-next'>&nbsp;</div></div>"));
                }
                $wrap.insertAfter(".p-image");
                if (typeof Swiper !== "undefined") {
                    mobileGallerySwiper = new Swiper(".mobile-gallery-swiper", {
                        slidesPerView: "auto",
                        spaceBetween: 10,
                        loop: true,
                        navigation: {
                            nextEl: ".mobile-gallery .myswiper-next",
                            prevEl: ".mobile-gallery .myswiper-prev"
                        },
                        breakpoints: {
                            0: {
                                slidesPerView: "auto",
                                slidesOffsetBefore: 10,
                                slidesOffsetAfter: 10,
                            },
                            768: {
                                slidesPerView: "auto",
                            }
                        }
                    });
                    $(document).on("change", "select.hidden-split-parameter", function () {
                        setTimeout(function () {
                            if (!mobileGallerySwiper) return;
                            var $highlighted = $(".p-thumbnails .p-thumbnail.highlighted");
                            var index = $(".p-thumbnails .p-thumbnail").index($highlighted);
                            var slideIndex = parseInt($(".mobile-gallery .swiper-slide[data-photo-index='" + index + "']").attr("data-swiper-slide-index"), 10);
                            if (index >= 0 && !isNaN(slideIndex)) {
                                mobileGallerySwiper.slideToLoop(slideIndex);
                            }
                        }, 50);
                    });
                }
            }
        }

        if ($(".p-detail-info .flag[style='background-color:#f5f7f7;']").length) {
            $("<div class='special-flags'></div>").appendTo(".p-info-wrapper");
            $(".p-detail-info .flag[style='background-color:#f5f7f7;']").appendTo(".special-flags");
        }

        $(".p-info-wrapper .availability-value").appendTo(".p-info-wrapper");
        $("<div class='mydelivery'>" + shopDataLayer.productDetail.delivery + "</div>").appendTo(".p-info-wrapper");
        $(".detail-parameters .delivery-time").appendTo(".mydelivery");
        $(".p-final-price-wrapper").insertBefore(".add-to-cart");   

        if($("#productsAlternative").length) {
            $("<div class='product-upsell'><div class='product-upsell-title'>" + shopDataLayer.productDetail.upsell.title + "</div><div class='product-upsell-products'></div></div>").insertAfter(".add-to-cart");
            $("#productsAlternative .product").appendTo(".product-upsell-products");
            $(".product-upsell .product .btn-primary").html(shopDataLayer.productDetail.upsell.detailText);
            $(".product-upsell .product .add-to-cart-button").html(shopDataLayer.productDetail.upsell.addToCartText);

            // Doporučení leží uvnitř formuláře detailu – Shoptet jim při výběru varianty přepíše priceId na zvolenou variantu
            $(".product-upsell .product input[name='priceId'], .product-upsell .product input[name='productId']").each(function () {
                $(this).attr("data-myvalue", $(this).val());
            });

            document.addEventListener("click", function (e) {
                const button = e.target.closest(".product-upsell .add-to-cart-button");
                if (!button) {
                    return;
                }

                $(button).closest(".product").find("input[data-myvalue]").each(function () {
                    $(this).val($(this).attr("data-myvalue"));
                });
            }, true);
        }

        $("tr.variant-list").each(function () {
            var $tr = $(this);
            var $td = $tr.find("td");
            var $select = $td.find("select.hidden-split-parameter");
            if (!$select.length) return;

            $select.addClass("myvariants-select-hidden");
            var $myvariants = buildMyvariantsFromSelect($select);
            $td.empty().append($select).append($myvariants);
        });

        $(document).on("click", ".myvariants .myvariant[data-parameter-id]", function () {
            var $variant = $(this);
            var value = $variant.data("value");
            var parameterId = $variant.data("parameter-id");
            var $block = $variant.closest(".myvariants");
            var $select = $("#parameter-id-" + parameterId);

            $select.val(value).trigger("change");
            $block.find(".myvariant").removeClass("selected active");
            $variant.addClass("selected active");
            myvariantsPressed();
        });

        function syncMyvariantActive($select) {
            var parameterId = $select.data("parameter-id") || $select.attr("id").replace("parameter-id-", "");
            var value = $select.val();
            var $block = $(".myvariants[data-parameter-id='" + parameterId + "']");
            $block.find(".myvariant").removeClass("selected active");
            $block.find(".myvariant[data-value='" + value + "']").addClass("selected active");
            myvariantsPressed();
        }

        $(".myvariants .myvariant").each(function () {
            var $variant = $(this);
            var value = $variant.data("value");
            var $select = $("#parameter-id-" + $variant.data("parameter-id"));
            if ($select.length && $select.val() === value) {
                $variant.addClass("selected active");
            }
        });

        myvariantsToButtons();
        $(window).on("load", myvariantsToButtons);

        $(document).on("change", "select.hidden-split-parameter", function () {
            syncMyvariantActive($(this));
        });

        $(".shp-tab-link[href='#relatedFiles']").text(shopDataLayer.productDetail.relatedFilesTitle);

        (function () {
            var $tabsList = $("#p-detail-tabs");
            var $tabContent = $("#tab-content");
            if (!$tabsList.length || !$tabContent.length) return;

            var $sections = $(".tab-section");
            if (!$sections.length) return;

            function slugify(text) {
                return text.toLowerCase()
                    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                    .replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
            }

            var $insertAfterLi = $tabsList.find(".shp-tab").first();
            var $insertAfterPane = $tabContent.find("#description");
            $sections.each(function () {
                var $section = $(this);
                var title = $section.attr("data-title") || "";
                if (!title) return;
                var id = "tab-" + slugify(title);
                var $pane = $("<div>")
                    .attr({ id: id, role: "tabpanel" })
                    .addClass("tab-pane fade")
                    .append($section.contents());
                $section.remove();
                $pane.insertAfter($insertAfterPane);
                $insertAfterPane = $pane;
                var $newLi = $("<li>")
                    .addClass("shp-tab")
                    .append($("<a>").attr({ href: "#" + id, role: "tab", "data-toggle": "tab" }).addClass("shp-tab-link").text(title));
                $newLi.insertAfter($insertAfterLi);
                $insertAfterLi = $newLi;
            });
        })();
        if($(".other-ig").length) {
            $(".other-ig").insertAfter(".content-wrapper-in");
            $(".products-related, .products-related-header").insertAfter(".other-ig");
        }
        else {
            $(".products-related, .products-related-header").insertAfter(".content-wrapper-in");
        }
    }
});

document.addEventListener("dkLabFavouriteProductsLoaded", function () {
    $(".p-info-wrapper #dkLabFavouriteDiv").appendTo(".p-info-wrapper .add-to-cart");
});